<!-- Modo MODAL (Tablero) o EN LA PÁGINA (vista de estación, inline). El cuerpo —
     leyendas, gráfica y cifras— es el mismo en los dos (bodyTpl). -->
<ng-container *ngIf="!inline; else inlineTpl">
<!-- Cierra solo al hacer clic en el fondo (target === currentTarget), SIN
     stopPropagation en el contenido: los ngx-select del modal se cierran con el
     clic en el documento, y frenar el evento los dejaba abiertos. -->
<div class="proj-overlay" (click)="$event.target === $event.currentTarget && close()">
    <div class="proj-modal" [class.proj-modal--wide]="dense">
        <div class="proj-head">
            <span class="proj-circ"><i class="fa fa-line-chart" aria-hidden="true"></i></span>
            <h5>Inventario proyectado</h5>
            <button type="button" class="proj-x" aria-label="Cerrar" (click)="close()">&times;</button>
        </div>
        <div class="proj-body" *ngIf="view">
            <div class="proj-sub">
                <!-- Tablero: estación con BUSCADOR (sin acentos, con estado vacío).
                     Vista de estación: solo su nombre, no hay a dónde cambiar. -->
                <div class="proj-station" *ngIf="stationSelector; else fixedStation">
                    <ngx-select [allowClear]="false" [items]="stationOptions" optionValueField="value" optionTextField="label"
                        placeholder="Buscar estación" [(ngModel)]="station" [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="pick()" [searchCallback]="stationSearch" [autoClearSearch]="true">
                        <ng-template ngx-select-option-not-found>Sin resultados</ng-template>
                    </ngx-select>
                </div>
                <ng-template #fixedStation><span class="proj-fixed">{{ view.row.stationName }}</span></ng-template>
                <!-- Producto con el MISMO control (sin buscador: son tres). -->
                <div class="proj-station proj-station--product">
                    <ngx-select [allowClear]="false" [noAutoComplete]="true" [items]="productOptions" optionValueField="value" optionTextField="label"
                        placeholder="Producto" [(ngModel)]="selectedProduct" [ngModelOptions]="{ standalone: true }" (ngModelChange)="pick()">
                    </ngx-select>
                </div>
                <!-- Semana anterior con «+ / −», igual que el calendario (revisión 12-oct). -->
                <button type="button" class="proj-week-btn" *ngIf="view.hasPrevWeek" [class.on]="showPrevWeek" (click)="togglePrevWeek()">
                    <b class="proj-week-btn__sign">{{ showPrevWeek ? '−' : '+' }}</b>Semana anterior
                </button>
                <!-- Tercera semana a pedido (jefe 19-oct, «dos semanas y media»): mismo control. -->
                <button type="button" class="proj-week-btn" *ngIf="view.hasThirdWeek" [class.on]="showThirdWeek" (click)="toggleThirdWeek()">
                    <b class="proj-week-btn__sign">{{ showThirdWeek ? '−' : '+' }}</b>Tercera semana
                </button>
            </div>
            <ng-container *ngTemplateOutlet="bodyTpl"></ng-container>
        </div>
        <div class="proj-foot">
            <button type="button" class="proj-btn" (click)="close()">Cerrar</button>
        </div>
    </div>
</div>
<!-- Backdrop idéntico al de los modales reales del flujo (bootstrap .modal-backdrop). -->
<div class="modal-backdrop fade show" (click)="close()"></div>
</ng-container>

<!-- Vista de estación (mock v3 «Análisis de Pedido»): sin ventana; el producto se
     elige con el mismo control segmentado de la página (punto de color). -->
<ng-template #inlineTpl>
    <div class="proj-inline" *ngIf="view">
        <div class="proj-sub">
            <span class="seg-prod">
                <span class="seg-prod__opt" *ngFor="let p of productOptions" [class.on]="selectedProduct === p.value" (click)="selectProduct(p.value)">
                    <i class="seg-prod__dot" [ngClass]="(mobicoFlow ? 'p-' : 'gp-') + p.value"></i>{{ p.label }}
                </span>
            </span>
            <button type="button" class="proj-week-btn" *ngIf="view.hasPrevWeek" [class.on]="showPrevWeek" (click)="togglePrevWeek()">
                <b class="proj-week-btn__sign">{{ showPrevWeek ? '−' : '+' }}</b>Semana anterior
            </button>
            <button type="button" class="proj-week-btn" *ngIf="view.hasThirdWeek" [class.on]="showThirdWeek" (click)="toggleThirdWeek()">
                <b class="proj-week-btn__sign">{{ showThirdWeek ? '−' : '+' }}</b>Tercera semana
            </button>
        </div>
        <ng-container *ngTemplateOutlet="bodyTpl"></ng-container>
    </div>
</ng-template>

<ng-template #bodyTpl>
    <!-- Leyendas en UNA barra contenida, con el orden del calendario (Edey 12-oct:
         «se ve raro»; «Tope» quedaba solo en un renglón): arriba las series y
         líneas de la gráfica; abajo color = producto y el proceso de la pipa. -->
    <!-- Arriba solo las series y líneas de la gráfica; las pipas van ABAJO, junto
         a sus fichas bajo la fecha (Edey 12-oct). -->
    <div class="proj-key">
        <span class="proj-key__k">Gráfica</span>
        <div class="proj-legend">
            <span><i class="sw" [style.background]="view.pal.base"></i>Inventario real</span>
            <!-- «Inventario teórico», no «Proyectado» (jefe 15-oct: «si yo no lo entiendo, ellos menos»;
                 es el teórico con la sugerencia, par de «Inventario real»). -->
            <span *ngIf="view.hasProjected"><i class="sw" [style.background]="view.pal.light"></i>Inventario teórico</span>
            <!-- Mismo orden que las fichas de abajo: Sugerida → Pendiente → En proceso (Edey 15-oct).
                 Pendiente: tinte del producto con borde a rayas, como su ficha. -->
            <span *ngIf="view.hasSuggested"><i class="sw sw-chip sw-chip--suggested" [style.border-color]="view.pal.base"></i>Sugerida</span>
            <span *ngIf="view.hasPending"><i class="sw sw-chip sw-chip--pendbar" [style.background]="view.pal.light" [style.border-color]="view.pal.pend"></i>Pendiente</span>
            <span *ngIf="view.hasConfirmed"><i class="sw sw-chip" [style.border-color]="view.pal.base"></i>En proceso</span>
            <span *ngIf="view.min"><i class="sw sw-chip sw-hatch"></i>Bajo el mínimo</span>
            <!-- Fuera de MOBICO: el faltante bajo el cero (ver pushPoint). -->
            <span *ngIf="view.hasShortfall"><i class="sw sw-chip sw-hatch"></i>Faltante (sin pedir)</span>
            <span *ngIf="view.min"><i class="sw sw-line sw-line--min"></i>Mínimo</span>
            <span *ngIf="view.threshold"><i class="sw sw-line sw-dashline"></i>Regla {{view.ruleDays}} días</span>
            <span *ngIf="view.target"><i class="sw sw-line sw-longdashline"></i>Objetivo</span>
            <span *ngIf="view.tope"><i class="sw sw-line sw-dotline"></i>Tope</span>
        </div>
    </div>
    <!-- Clic en las fichas bajo la fecha (Edey 15-oct): se delega aquí y se emite chipClick. -->
    <div (click)="onChartClick($event)">
        <highcharts-chart class="proj-chart" [Highcharts]="Highcharts" [options]="options" [oneToOne]="true"></highcharts-chart>
    </div>
    <!-- Pipas bajo la fecha: el proceso, junto a las fichas del eje (Edey 12-oct),
         y la clave de color al extremo derecho. -->
    <div class="proj-xlegend" [class.proj-xlegend--tight]="tightChips || dense">
        <ng-container *ngIf="mobicoFlow || view.hasSuggested">
        <span class="proj-key__k">Pipas (litros):</span>
        <span class="proj-xlegend__step"><span class="proj-x-chip proj-x-chip--suggested" [style.border-color]="view.pal.base" [style.color]="view.pal.base"><i class="fa fa-truck" aria-hidden="true"></i>+20,000</span>Sugerida</span>
        <span class="proj-xlegend__step" *ngIf="mobicoFlow"><span class="proj-x-chip proj-x-chip--pending" [style.border-color]="view.pal.pend" [style.color]="view.pal.base" [style.background]="view.pal.light"><i class="fa fa-truck" aria-hidden="true"></i>10,000</span>Pendiente</span>
        <span class="proj-xlegend__step" *ngIf="mobicoFlow"><span class="proj-x-chip" [style.border-color]="view.pal.base" [style.color]="view.pal.base"><i class="fa fa-truck" aria-hidden="true"></i>30,000</span>En proceso</span>
        <span class="proj-xlegend__step" *ngIf="mobicoFlow"><span class="proj-x-chip proj-x-chip--arrived" [style.border-color]="view.pal.base" [style.background]="view.pal.base"><i class="fa fa-truck" aria-hidden="true"></i>30,000</span>Llegó</span>
        <!-- ⓘ con la diferencia entre estados (2.ª revisión 12-oct). -->
        <span class="proj-tip" *ngIf="mobicoFlow">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            <span class="proj-tip__pop">
                <b>Cómo va una pipa</b>
                <span><b>Sugerida</b>: la propone el sistema; todavía nadie la pide.</span>
                <span><b>Pendiente</b>: la estación ya la pidió y MOBICO aún no la aprueba.</span>
                <span><b>En proceso</b>: MOBICO la aprobó y tiene fecha de entrega, pero aún no se confirma que llegó.</span>
                <span><b>Llegó</b>: entrega confirmada, con los litros recibidos.</span>
            </span>
        </span>
        </ng-container>
        <span class="proj-xlegend__product"><span class="proj-key__k">Color = producto:</span><i class="sw" [style.background]="view.pal.base"></i>{{ view.row.productLabel }}</span>
    </div>
    <!-- Cifras en UNA fila, etiqueta pegada a su valor (08-oct tarde: con dos
         columnas a los extremos "Tope y Venta diaria quedaban muy lejos"). -->
    <div class="proj-facts">
        <div><span>Inventario hoy</span><b>{{view.stock != null ? (view.stock | number: '1.0-0') + ' lts' : '—'}}<ng-container *ngIf="view.daysLeft != null"> · {{view.daysLeft | number: '1.1-1'}} días</ng-container></b></div>
        <div><span>Venta diaria</span><b>{{view.sale != null ? (view.sale | number: '1.0-0') + ' lts' : '—'}}</b></div>
        <div><span>Mínimo</span><b>{{view.min ? (view.min | number: '1.0-0') + ' lts' : '—'}}</b></div>
        <!-- Solo las reglas definidas: N días de venta = N × venta (Edey 09-oct). -->
        <div *ngIf="view.threshold"><span>Regla {{view.ruleDays}} días</span><b>{{view.threshold | number: '1.0-0'}} lts</b></div>
        <div *ngIf="view.target"><span>Objetivo</span><b>{{view.target | number: '1.0-0'}} lts</b></div>
        <div><span>Tope</span><b>{{view.tope ? (view.tope | number: '1.0-0') + ' lts' : '—'}}</b></div>
    </div>
</ng-template>
